module.exports = __webpack_public_path__ + "img/framenew_box27.b53db868.jpg";